import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { reApi, errMsg } from "@/lib/residentApi";
import ProfileTab from "@/components/nds/windows/resident/ProfileTab";
import MemoBoardTab from "@/components/nds/windows/resident/MemoBoardTab";
import WeeklyCheckinFix from "@/components/nds/windows/checkin/WeeklyCheckinFix";
import CalendarTab from "@/components/nds/windows/resident/CalendarTab";
import FinancialTab from "@/components/nds/windows/resident/FinancialTab";
import ReviewsTab from "@/components/nds/windows/resident/ReviewsTab";
import PillarFixPanel from "@/components/nds/PillarFixPanel";
import { LifePassPin } from "@/components/nds/windows/pillar/LifePassPin";

const PILLAR = { case_mgmt: "PILLAR_1_INNER", life_skills: "PILLAR_2_VOCATION", spiritual: "PILLAR_3_SPIRIT", checkin_pillar: "PILLAR_4_DAILY", pillar_verification: null, pillar_assignment: null };
const TAB = { review: ReviewsTab, rent: FinancialTab, money: FinancialTab, schedule: CalendarTab, room: ProfileTab, room_ready: ProfileTab, property: ProfileTab, intake: ProfileTab, memos: MemoBoardTab };

export const canFixHere = (key) => key in PILLAR || key in TAB || key === "portal" || key === "weekly_checkin";

/** The one part of a resident's file a "Who needs what" card is about, opened right in the side panel. */
export function FixPanel({ cardKey, residentId, residentName, onChanged }) {
  const [resident, setResident] = useState(null);
  const [error, setError] = useState(null);
  const load = () => reApi.get(`/residents/${residentId}`).then(setResident).catch((e) => setError(errMsg(e)));
  useEffect(() => {
    if (TAB[cardKey]) load();
  }, [cardKey, residentId]); // eslint-disable-line react-hooks/exhaustive-deps
  const changed = () => { if (TAB[cardKey]) load(); onChanged?.(); };
  if (error) return <p className="text-xs text-red-300" data-testid="rd-fix-error">{error}</p>;
  if (cardKey === "portal") return <LifePassPin residentId={residentId} />;
  if (cardKey === "weekly_checkin") return <WeeklyCheckinFix residentId={residentId} residentName={residentName} onChanged={onChanged} />;
  if (cardKey in PILLAR) return <PillarFixPanel residentId={residentId} only={PILLAR[cardKey]} mode={cardKey} onChanged={onChanged} />;
  const Tab = TAB[cardKey];
  return resident ? <Tab resident={resident} onChanged={changed} manage /> : <Loader2 className="h-4 w-4 animate-spin" />;
}
